export default __webpack_public_path__ + "static/media/TodayWideCarrousel.6bb78e90.png";